import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./BillingComponent.module.css";
import { fetchProceduresList, fetchModifierLookup, fetchExternalPractitionerList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { LineItemObj, ConsultationCodes } from "../../../utils/BillingConstants";
import ModifiersRules from "../../../utils/ModifiersRules.json";
import { ageDifferenceInDays, ageDifferenceInYears, isEmpty, showAlert } from "../../../utils/CommonUtil";
import swal from "sweetalert";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import moment from "moment";
import _ from "lodash";


export class Modifiers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search_filter: "code",
            search_key: "",
            page: 1,
            sortName: "",
            sortOrder: "",
            sortBy: "",
            practitioner_id: "",
            patient_id: "",
            lineItemsArray: [],
            isDataFetched: false,
            list: [],
            errorMessage: "",
            isLoading: false,
            isModalOpen: false,
            duration: "",
            selectedRow: {},
            is0018ModalOpen: false,
            height: 0,
            weight: 0,
            heightInMtr: 0,
            weightInKg: 0,
            BMI: 0,
            bmiErrorMessage: "",
            isExternalPracModalOpen: false,
            externalPractitionerId: "",
            externalPracPaylaod: {
                search_key: "",
                page: 1,
                sortName: "",
                sortOrder: "",
                sortBy: "",
            }
        };
        this.setLoader = this.setLoader.bind(this);
    }


    componentDidMount = async () => {
        if (this.props.state &&
            this.props.state.requested_professional &&
            this.props.state.related_party) {

            this.setState({
                practitioner_id: this.props.state.requested_professional,
                patient_id: this.props.state.related_party,
                height: this.props.state.height,
                heightInMtr: this.props.state.height ? (this.props.state.height / 100) : "",
                weight: this.props.state.weight,
                weightInKg: this.props.state.weight ? (this.props.state.weight / 1000) : "",
                diagnosis_string: this.props.diagnosis_string
            },()=>{
                this.calculateBMI();
            })

        }
        this.setState({
            lineItemsArray: this.props.lineItemsArray,
        })

        const payload = this.getPayload();
        await this.props.fetchProceduresList(this.state.page, payload);

        if (this.props.proceduresListData &&
            this.props.proceduresListData.proceduresList.tariffCodes &&
            this.props.proceduresListData.proceduresList.tariffCodes.pageResult) {
            this.setState({
                list: this.props.proceduresListData.proceduresList.tariffCodes.pageResult
            })
        }
        setTimeout(() => {
            this.setState({
                isDataFetched: true,
            });
        }, 1000);

    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.state.requested_professional !== this.props.state.requested_professional ||
            prevProps.state.related_party !== this.props.state.related_party ||
            prevProps.lineItemsArray !== this.props.lineItemsArray ||
            prevProps.state.height !== this.props.state.height  ||
            prevProps.state.weight  !== this.props.state.weight ) {

            //console.log("this.props",this.props);
            this.setState({
                practitioner_id: this.props.state.requested_professional,
                patient_id: this.props.state.related_party,
                lineItemsArray: this.props.lineItemsArray,
                diagnosis_string: this.props.diagnosis_string,
                height: this.props.state.height,
                heightInMtr: this.props.state.height ? (Number(this.props.state.height) / 100) : "",
                weight: this.props.state.weight,
                weightInKg: this.props.state.weight ? (Number(this.props.state.weight) / 1000) : "",
            },()=>{
                this.calculateBMI();
            })
           // console.log("modifiers updated", this.state)

        }
    }

    getPayload = () => {
        return {
            search_filter: this.state.search_filter,
            search_key: this.state.search_key,
        };
    }

    callListAPI = async () => {
        this.setState({
            list: []
        })

        const payload = this.getPayload();
        await this.props.fetchProceduresList(this.state.page, payload);

        if (this.props.proceduresListData &&
            this.props.proceduresListData.proceduresList &&
            this.props.proceduresListData.proceduresList.tariffCodes &&
            this.props.proceduresListData.proceduresList.tariffCodes.pageResult) {
            this.setState({
                list: this.props.proceduresListData.proceduresList.tariffCodes.pageResult
            })
        }
        setTimeout(() => {
            this.setState({
                isDataFetched: true,
            });
        }, 500);

    }

    callExternalListAPI = async() => {
        const payload = {
            page: this.state.externalPracPaylaod.page,
            search_key: this.state.externalPracPaylaod.search_key,
            sortName: this.state.externalPracPaylaod.sortName,
            sortOrder: this.state.externalPracPaylaod.sortOrder,
            sortBy: this.state.externalPracPaylaod.sortBy,
        }
        await this.props.fetchExternalPractitionerList(payload);
    }

    onSortChange = (sortName, sortOrder) => {
        let sortBy;
        if (sortOrder === "desc") {
            sortBy = "-" + sortName;
        } else {
            sortBy = sortName;
        }
        this.setState({
            sortName,
            sortOrder,
            sortBy,
            page: 1,
            isDataFetched: false,
        }, () => {
            this.callListAPI();
        });

    };

    onExtSortChange = (sortName, sortOrder) => {
        let sortBy;
        if (sortOrder === "desc") {
            sortBy = "-" + sortName;
        } else {
            sortBy = sortName;
        }
        this.setState({
            externalPracPaylaod: {
                ...this.state.externalPracPaylaod,
                sortName,
                sortOrder,
                sortBy,
                page: 1,
            }
        }, () => {
            this.callExternalListAPI();
        });

    };

    onExtPageChange = (page, sizePerPage) => {
        this.setState({
            externalPracPaylaod: {
                ...this.state.externalPracPaylaod,
                page,
            }
        }, () => {
            this.callExternalListAPI();
        });
    };

    onPageChange = (page, sizePerPage) => {
        this.setState({
            page,
            isDataFetched: false
        }, () => {
            this.callListAPI();
        });
    };

    onExtSearchChange = (search_key) => {
        this.setState({
            externalPracPaylaod: {
                ...this.state.externalPracPaylaod,
                search_key,
            }
        }, () => {
            this.callExternalListAPI();
        });
    };

    nameFormatter(cell, row){
        if (!cell && !row.surname) return "Not Available";
        return ((cell ? (cell.charAt(0).toUpperCase() + cell.slice(1)): "") + " " +
        (row.surname ? (row.surname.charAt(0).toUpperCase() + row.surname.slice(1)):""))
      }

      handleAddExternalPractitioner = (row) => {
          console.log("second click")
        this.setState({
            externalPractitionerId: row && row.related_party_id ? row.related_party_id : "",
            isExternalPracModalOpen: false
        },()=>{
            this.handleAddModifier(this.state.selectedRow);
        })
      }

    handleInputChange = (event) => {
        let val = event.target.value;

        this.setState({
            search_key: val,
            page: 1,
            isDataFetched: false
        }, () => {
            this.callListAPI();
        })
    }

    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        if(name === "heightInMtr"){
            // conver to meters
           let val = value * 100;
            this.setState({
                height: val
            })
        }

        if(name === "weightInKg"){
            //convert to gms
            let val =value * 1000 ;
            this.setState({
                weight: val
            })
        }

        this.setState({
            [name]: value
        }, () => {
            this.calculateBMI();
        })
    }

    calculateBMI = () => {
        let BMI = 0
        let ht = this.state.heightInMtr;
        let wt = this.state.weightInKg;
        if (ht && wt && Number(wt) !== "NaN" && Number(ht) !== "NaN") {

            //let htSquare = Number(ht) / 100 * Number(ht) / 100;
           // wt = Number(wt) / 1000;
            BMI = wt / (ht * ht);
            BMI = BMI ? BMI.toFixed(2) : 0;
        }
        this.setState({
            BMI: BMI
        })
    }

    handleDurationChange = (event) => {
        let val = event.target.value;
        this.setState({
            duration: val
        })
    }

    handleSubmit = () => {
        this.setState({
            isModalOpen: false
        }, () => {
            this.handleAddModifier(this.state.selectedRow)
        })
    }

    handleSubmitBMI = () => {
        if (Number(this.state.BMI) > 35) {
            this.setState({
                is0018ModalOpen: false,
            }, () => {
                let data = {
                    height: this.state.height,
                    weight: this.state.weight,
                }
                this.props.updateHeightWeight(data);
                this.handleAddModifier(this.state.selectedRow);
            })
        } else {
            this.setState({
                bmiErrorMessage: "BMI is less than 35."
            })

            setTimeout(() => {
                this.setState({
                    bmiErrorMessage: "",
                })

            }, 2000);
        }
    }

    handleInputSelectChange = (event) => {
        let filterval = event.target.value;

        this.setState({
            [event.target.name]: filterval,
            page: 1,
            isDataFetched: false
        }, () => {
            this.callListAPI();
        })
    }


    getPercentageVal = (price, percentage) => {
        let val = 0;
        if (percentage) {
            val = Number(price) * (Number(percentage) / 100);
        }
        return Number(val);
    }

    showAlert = (msg) => {
        swal(msg, {
            className: "logout-swal-modal",
            buttons: "ok",
        });
    }

    // toggle a modal
    toggle = (val) => {
        this.setState((prevState) => ({
            isModalOpen: !prevState.isModalOpen,
            duration: "",
        }));
    }

    // toggle a modal
    toggleBMIModal = (val) => {
        this.setState((prevState) => ({
            is0018ModalOpen: !prevState.is0018ModalOpen,
            // height: "",
            // weight: ""
        }));
    }


    toggleExternalPractitionerModal = async(val) => {
        this.setState((prevState) => ({
            isExternalPracModalOpen: !prevState.isExternalPracModalOpen,
            externalPractitionerId: "",
            externalPracPaylaod:{
                ...this.state.externalPracPaylaod,
                search_key: "",
                page: 1,
                sortName: "",
                sortOrder: "",
                sortBy: "",
            }
        }),async()=>{
            if(this.state.isExternalPracModalOpen === true){
                await this.callExternalListAPI();
            }
        });
    }

    additionModifier = (payload, modifier) => {
        let modifierArray = [];
        let indexArray = []
        let lineItemsArray = [...this.state.lineItemsArray];
        lineItemsArray && lineItemsArray.forEach((item, index) => {
            if (item.line_item_checked && item.line_item_checked === 1 && item.delete !== true) {

                let payloadObj = { ...payload };
                indexArray.push(index);
                payloadObj.index = index;
                payloadObj.diagnosis_code = item.diagnosis_code;
                if (modifier.percentage) {
                    let price = this.getPercentageVal(Number(item.calculatedPrice), modifier.percentage);
                    payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                    payloadObj.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                } else if (modifier.unitVal) {
                    payloadObj.numberOfUnits = Number(modifier.unitVal);
                    let units = payloadObj.numberOfUnits ;
                    let price = Number(units) * Number(item.perUnitPrice);
                    payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                    payloadObj.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                }
                if (item.nappi_code) {
                    payloadObj.parentNappiCode = item.nappi_code
                    payloadObj.reference_id += "-" + item.reference_id;
                } else if (item.tariff_code) {
                    payloadObj.parentTariffCode = item.tariff_code
                    payloadObj.reference_id += "-" + item.reference_id;

                    let lineTypeIndex = lineItemsArray.findIndex((element) => (
                        element.tariff_code === item.tariff_code && element.delete !== true && element.childAdditionAdded !== true 
                    ))
                    if(lineTypeIndex > -1){
                        lineItemsArray[lineTypeIndex].childAddition = payloadObj.tariff_code;
                        lineItemsArray[lineTypeIndex].childAdditionAdded = true
                    }
                }

                modifierArray.push(payloadObj);
            }
        })
        return {modifierArray, indexArray};
    }


    reductionModifier = (payload, modifier) => {
        let modifierArray = [];
        let indexArray = [];
        let lineItemsArray = [...this.state.lineItemsArray];
        lineItemsArray && lineItemsArray.forEach((item, index) => {
            if (item.line_item_checked && item.line_item_checked === 1 && item.delete !== true) {
                let payloadObj = { ...payload };
                indexArray.push(index);
                payloadObj.index = index;
                payloadObj.diagnosis_code = item.diagnosis_code;
                if (modifier.percentage) {
                    let price = Number(item.calculatedPrice) - this.getPercentageVal(Number(item.calculatedPrice), modifier.percentage);
                    price = price ? Number(price.toFixed(2)) : 0;
                    payloadObj.base_price = this.getPercentageVal(Number(item.calculatedPrice), modifier.percentage);
                    if(this.props.claimAsAssistant === 0){
                        lineItemsArray[index].price = price
                    }
                    lineItemsArray[index].calculatedPrice = price
                }
                if (item.nappi_code) {
                    payloadObj.parentNappiCode = item.nappi_code
                    payloadObj.reference_id += "-" + item.reference_id;
                } else if (item.tariff_code) {
                    payloadObj.parentTariffCode = item.tariff_code
                    payloadObj.reference_id += "-" + item.reference_id;
                }
                modifierArray.push(payloadObj);
            }
        })
        return { modifierArray, lineItemsArray, indexArray };
    }

    handleCheckModifier = async (row) => {


        let lineItemsArray = [...this.state.lineItemsArray];
        if (!this.state.practitioner_id || !this.state.patient_id) {
            showAlert("Please select practitioner and patient first!");
            return false;
        }

        let errorPopshow = false;
        let modifier = ModifiersRules.Modifiers.find((tariffCode, index) => (
            row.code === tariffCode.code
        ))


        if(row.code === "0043" && this.props.state && this.props.state.dob ){
            let diff = ageDifferenceInYears(this.props.state.dob);
            if(diff > 1 && diff < 70){
                showAlert("This modifier may not be applicable for this patient!");
                return false;
            }
        }

        if(row.code === "0044" && this.props.state && this.props.state.dob ){
            let diff = ageDifferenceInDays(this.props.state.dob);
            if(diff > 28){
                showAlert("This modifier may not be applicable for this patient!");
                return false;
            }
        }


        if (lineItemsArray && lineItemsArray.length === 0) {
            showAlert("Please add a line type item first!");
            return false;
        } else if (modifier && modifier.selectionRequired === 1) {
            let checkedLineItems = lineItemsArray.filter((item) => (
                item.line_item_checked === 1 && item.delete !== true
            ))
            if (!checkedLineItems || checkedLineItems.length === 0) {
                showAlert("Please select any line type item first!");
                return false;
            }

            if (checkedLineItems && checkedLineItems.length > 1 && row.code === "0011") {
                showAlert("Please select only one Procedure line type item for 0011 modifier to avoid over claiming!");
                return false;
            }

            if (modifier && modifier.notApplicableTo && modifier.notApplicableTo.length > 0 && modifier.code !== "0005" && modifier.extraRule !== 1  ) {
                let excludeFlag = checkedLineItems && checkedLineItems.findIndex((elem) => (
                    elem.tariff_code && modifier.notApplicableTo.length > 0 && elem.delete !== true &&
                    (modifier.notApplicableTo.indexOf(elem.tariff_code) > -1)
                ))
               
                if (Number(excludeFlag) !== "NaN" && Number(excludeFlag) > -1) {
                    errorPopshow = true;
                    const continueFlag = await swal(row.code + " modifier may not be associated with one or more selected procedures. Do you still want to continue adding?", {
                        className: "logout-swal-modal",
                        buttons: ["Cancel", "Continue"],
                    });

                    if (continueFlag) {
                        errorPopshow = false;
                    }else{
                        return false;
                    }
                }
            }


            if (modifier && modifier.notApplicableWith && modifier.notApplicableWith.length > 0) {
                let notApplicableFlag = -1;
                checkedLineItems && checkedLineItems.length > 0 && checkedLineItems.forEach((item) => {
                    notApplicableFlag = lineItemsArray && lineItemsArray.findIndex((elem) => (
                        elem.line_type === "modifier" && elem.tariff_code &&
                        modifier.notApplicableWith.length > 0 && elem.delete !== true &&
                        item.tariff_code === elem.parentTariffCode &&
                        (modifier.notApplicableWith.indexOf(elem.tariff_code) > -1)
                    ))

                    if (Number(notApplicableFlag) !== "NaN" && Number(notApplicableFlag) > -1) {
                        return notApplicableFlag;
                    }

                })
                if (Number(notApplicableFlag) !== "NaN" && Number(notApplicableFlag) > -1) {
                    errorPopshow = true;
                    const continueFlag = await swal(row.code + " modifier may not be applicable with one of already added modifier. Do you still want to continue adding?", {
                        className: "logout-swal-modal",
                        buttons: ["Cancel", "Continue"],
                    });

                    if (continueFlag) {
                        errorPopshow = false;
                    }else{
                        return false;
                    }
                }

            }

            if (modifier && modifier.lowerLimit) {
                let limitFlag = checkedLineItems && checkedLineItems.findIndex((elem) => (
                    elem.line_type === "procedure" && elem.numberOfUnits !== "" && elem.delete !== true &&
                    elem.numberOfUnits < modifier.lowerLimit
                ))
                if (Number(limitFlag) !== "NaN" && Number(limitFlag) > -1) {
                    errorPopshow = true;
                    const continueFlag = await swal(row.code + " modifier only applies to procedures more than " + modifier.lowerLimit + " procedure units. Do you still want to continue adding?", {
                        className: "logout-swal-modal",
                        buttons: ["Cancel", "Continue"],
                    });

                    if (continueFlag) {
                        errorPopshow = false;
                    }else{
                        return false;
                    }
                }

            }

            //No modifier applies to these consultation codes
         let consultationCode = [...ConsultationCodes];
         
         let consultationExists = checkedLineItems && checkedLineItems.find((elem) => (
                 (consultationCode.indexOf(elem.tariff_code) > -1) && elem.delete !== true 
             ))

         if (!isEmpty(consultationExists)) {
             errorPopshow = true;
             const continueFlag = await swal("A Modifier may not be associated with this consultation. Do you still want to continue adding?", {
                 className: "logout-swal-modal",
                 buttons: ["Cancel", "Continue"],
             });

             if (continueFlag) {
                 errorPopshow = false;
             }else{
                return false;
            }
         }

        }

         


        if (errorPopshow === false) {
            if (row && (row.code === "0011" || row.code === "0018" || row.code === "0039" || row.code === "0008"  || row.code === "0009")) {
                this.setState({
                    selectedRow: row
                }, () => {
                    if (row.code === "0011" || row.code === "0039") {
                        this.toggle();
                    } else if (row.code === "0018") {
                        this.toggleBMIModal();
                    }else if( row.code === "0008" || row.code === "0009"){
                        this.toggleExternalPractitionerModal();
                    }
                })
            } else {
                this.handleAddModifier(row);
            }

        }
    }

    handleAddModifier = async (row) => {

        let lineItemsArray = [...this.state.lineItemsArray];
        let modifier = ModifiersRules.Modifiers.find((tariffCode, index) => (
            row.code === tariffCode.code
        ))
        this.setState({
            isLoading: true
        })
        // const apiPayload = {
        //     practitioner_id: this.state.practitionerb_id,
        //     patient_id: this.state.patient_id,
        //     tariff_code: row.Code,
        // }


       // await this.props.fetchModifierLookup(apiPayload);

       // if (!this.props.modifierLookupData.loading && !this.props.modifierLookupData.error) {
        if (row) {
         //   let data = this.props.modifierLookupData.modifierLookup;


            const payload = { ...LineItemObj };
 
            payload.isClaimed = 1;
            payload.line_type = "modifier";
            payload.tariff_code = row.code;
            payload.description = row.description.substring(0, 70);
            payload.startdatetime = this.props.state && this.props.state.startdatetime ? moment(this.props.state.startdatetime).format("YYYY-MM-DD HH:mm"): "" ;
            payload.enddatetime =  this.props.state && this.props.state.enddatetime ? moment(this.props.state.enddatetime).format("YYYY-MM-DD HH:mm"): "" ;
            payload.diagnosis_code = this.state.diagnosis_string;
            if(row.code === "0008" || row.code === "0009"){
                payload.doctor_id = this.state.externalPractitionerId
            }else{
                payload.doctor_id = this.state.practitioner_id;
            }
            payload.modifierType = modifier && modifier.type ? modifier.type : "IM";
            payload.reference_id = row.code;

            let modifierArray = [];
            let indexArray = [];
            let currentIndex;
            let nextTreatmentIndex;
            if (!isEmpty(modifier)) {
                if ((modifier.type === "AM" || modifier.type === "CM") && modifier.extraRule === 0) {

                    // generalised rule for addition modifiers which does not require extra rule.
                    // [modifierArray, indexArray] = [...this.additionModifier(payload, modifier)];
               let finalObj = {...this.additionModifier(payload, modifier)};
                        modifierArray = finalObj && [...finalObj.modifierArray];
                        indexArray = finalObj && [...finalObj.indexArray]


                } else if (modifier.type === "RM" && modifier.extraRule === 0) {

                    // generalised rule for reduction modifiers which does not require extra rule.
                    let finalObj = { ...this.reductionModifier(payload, modifier) };
                    modifierArray = finalObj && [...finalObj.modifierArray];
                    lineItemsArray = finalObj && [...finalObj.lineItemsArray];
                    indexArray = finalObj && [...finalObj.indexArray]

                } else if (modifier.type === "AM" && modifier.extraRule === 1) {
                    //Rule for 0010 modifier
                    if (modifier.code === "0010") {
                        // let modifierExist = lineItemsArray && lineItemsArray.filter((item) => {
                        //     return item.line_type === "modifier" && item.delete !== true &&
                        //     item.tariff_code === "0010";
                        // })
                        let procedureLineType = [];
                        lineItemsArray && lineItemsArray.map((item, index) => {
                            if(item.line_type === "procedure" && item.delete !== true &&
                            item.line_item_checked && item.line_item_checked === 1)
                            procedureLineType.push({...item, index});
                            return;
                        })
                        if (procedureLineType && procedureLineType.length === 1) {
                            procedureLineType && procedureLineType.forEach((item) => {
                                let payloadObj = { ...payload };
                                indexArray.push(item.index);
                                payloadObj.index = item.index;
                                payloadObj.diagnosis_code = item.diagnosis_code;

                                //if number of units is less than 7 minimum Aneasthetic units.
                                if (item.anestheticUnits) {
                                    payloadObj.numberOfUnits = Number(item.anestheticUnits) < 7 ? 7 : item.anestheticUnits ;
                                    let price = item.anestheticUnitValue ? (Number(payloadObj.numberOfUnits) * Number(item.anestheticUnitValue)) : 0;
                                    payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                                    payloadObj.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                                }
                                if (item.tariff_code) {
                                    payloadObj.parentTariffCode = item.tariff_code
                                    payloadObj.reference_id += "-" + item.reference_id;
                                    let lineTypeIndex = lineItemsArray.findIndex((element) => (
                                        element.tariff_code === item.tariff_code && element.delete !== true 
                                    ))
                                    if(lineTypeIndex > -1){
                                        lineItemsArray[lineTypeIndex].childAddition = payloadObj.tariff_code
                                    }
                                }
                                modifierArray.push(payloadObj);
                            })
                        }else {
                           let sumofUnits = procedureLineType && procedureLineType.reduce((prev,next) => prev + Number(next.anestheticUnits),0);
                           
                            if (sumofUnits > 30) {
                                const continueFlag = await swal("0010 Modifier may not be applicable on total number of units more than 30. Do you still want to add this modifier?", {
                                    className: "logout-swal-modal",
                                    buttons: ["NO", "YES"],
                                });
                
                                if (!continueFlag) {
                                    return false;
                                }
                            }
                            let payloadObj = { ...payload };
                            payloadObj.diagnosis_code = procedureLineType[0].diagnosis_code;
                            //if number of units is less than 7 minimum Aneasthetic units.
                            if (sumofUnits) {
                                payloadObj.numberOfUnits = sumofUnits < 7 ? 7 : sumofUnits ;
                                let price = procedureLineType[0].anestheticUnitValue ? (Number(payloadObj.numberOfUnits) * Number(procedureLineType[0].anestheticUnitValue)) : 0;
                                payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                                payloadObj.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                            }
                            modifierArray.push(payloadObj);
                        }
                    }else if (modifier.code === "0018") {
                        
                        // extract only procedures from the array
                        let procedureLineType = [];
                        lineItemsArray && lineItemsArray.map((item, index) => {
                            if(item.line_type === "procedure" && item.delete !== true)
                            procedureLineType.push({...item,index});
                            return;
                        })
                        let consultationCode = [...ConsultationCodes];
                        let consultationExists = procedureLineType && procedureLineType.find((elem) => (
                            (consultationCode.indexOf(elem.tariff_code) > -1) && elem.delete !== true
                        ))
                        if (!isEmpty(consultationExists)) {
                            const continueFlag = await swal("A Modifier may not be associated with one of the consultation. Do you want to add this modifier to all?", {
                                className: "logout-swal-modal",
                                buttons: ["NO", "YES"],
                            });
               
                            if (!continueFlag) {
                                let array = [...procedureLineType];
                                procedureLineType = array.filter((elem) => (
                                    elem.tariff_code && elem.delete !== true &&
                                    (consultationCode.indexOf(elem.tariff_code) === -1)
                                ))
                            }
                        }
                        if (procedureLineType || procedureLineType.length > 0) {
                            let modiferPercent = modifier.percentage;
                            procedureLineType && procedureLineType.forEach((item) => {
                                let payloadObj = { ...payload };
                                indexArray.push(item.index);
                                payloadObj.index = item.index;

                                currentIndex = item.index; 

                                nextTreatmentIndex = lineItemsArray.findIndex((elem, index) => elem.line_type == "procedure" && index > currentIndex && elem.delete !== true);
                                nextTreatmentIndex = nextTreatmentIndex == -1 ? 100000 : nextTreatmentIndex;

                                payloadObj.diagnosis_code = item.diagnosis_code;
                                payloadObj.markupPercent = modiferPercent;
                                payloadObj.description = "Height is "+ this.state.heightInMtr + "M, Weight is "+this.state.weightInKg +"Kg and Calculated BMI is " + this.state.BMI;
                                // percentage calculation
                                if (modiferPercent) {
                                    let price = this.getPercentageVal(Number(item.calculatedPrice), modiferPercent)
                                    payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                                    payloadObj.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                                }

                                //Assign parent tariff code to the modifier to reference
                                if (item.tariff_code) {
                                    payloadObj.parentTariffCode = item.tariff_code
                                    payloadObj.reference_id += "-" + item.reference_id;
                                    let lineTypeIndex = lineItemsArray.findIndex((element) => (
                                        element.tariff_code === item.tariff_code && element.delete !== true 
                                    ))
                                    if(lineTypeIndex > -1){
                                        lineItemsArray[lineTypeIndex].childAddition = payloadObj.tariff_code
                                    }
                                }
                                if(this.props.claimAsAssistant === 0){
                                    modifierArray.push(payloadObj);
                                }
                                
                                let searchModifier = [];
                                lineItemsArray.map((elem, index) => {
                                    if((elem.parentTariffCode === item.tariff_code || (elem.superParentTariffCode === item.tariff_code && 
                                        (elem.parentTariffCode === "0008" || elem.parentTariffCode === "0009") ))
                                     && index > currentIndex && index < nextTreatmentIndex && elem.delete !== true &&  elem.line_type === "modifier" && (elem.modifierType === "AM" ||
                                    elem.modifierType === "CM") && elem.tariff_code !== "0011")
                                    searchModifier.push({...elem, index})
                                    return;
                                    })

                                if (searchModifier && searchModifier.length > 0) {
                                    searchModifier.forEach((obj) => {
                                        let payloadObj1 = { ...payloadObj };
                                        indexArray.push(obj.index);
                                        payloadObj1.index = obj.index;
                                        if(obj.tariff_code !== "0008" && obj.tariff_code !== "0009"){
                                            if (modiferPercent) {
                                                let price = this.getPercentageVal(Number(obj.calculatedPrice), modiferPercent)
                                                payloadObj1.price = price ? Number(price.toFixed(2)) : 0;
                                                payloadObj1.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                                            }
                                        }
                                        payloadObj1.doctor_id = obj.doctor_id;
                                        if (item.tariff_code) {
                                            payloadObj1.parentTariffCode = obj.tariff_code;
                                            payloadObj1.superParentTariffCode = item.tariff_code;

                                            payloadObj1.reference_id = row.code + "-" + obj.reference_id;
                                            // if(obj.tariff_code === "0008" || obj.tariff_code === "0009"){
                                            //     payloadObj1.reference_id += "-" + obj.parentTariffCode;
                                            // }
                                            // payloadObj1.reference_id += "-" + payloadObj1.superParentTariffCode;
                                            let lineTypeIndex = lineItemsArray.findIndex((element) => {
                                              return (element.tariff_code === obj.tariff_code && 
                                                (element.parentTariffCode ===  item.tariff_code || 
                                                element.superParentTariffCode === item.tariff_code) &&
                                                !element.childAddition && element.delete !== true )
                                                })
                                            if(lineTypeIndex > -1){
                                                lineItemsArray[lineTypeIndex].childAddition = payloadObj1.tariff_code
                                            }
                                        }
                                        modifierArray.push(payloadObj1);
                                    });
                                }
                            })
                        }
                    } else if (modifier.code === "0048" || modifier.code === "0049" || modifier.code === "0051" ||
                        modifier.code === "0052" || modifier.code === "0053" || modifier.code === "0055") {
                        lineItemsArray && lineItemsArray.forEach((item, index) => {
                            //check for selected procedures.
                            if (item.line_item_checked && item.line_item_checked === 1 && item.delete !== true) {

                                 currentIndex = index; 

                                nextTreatmentIndex = lineItemsArray.findIndex((elem, index) => elem.line_type == "procedure" && index > currentIndex && elem.delete !== true);
                                nextTreatmentIndex = nextTreatmentIndex == -1 ? 100000 : nextTreatmentIndex;

                                let payloadObj = { ...payload };
                                indexArray.push(index);
                                payloadObj.index = index;
                                payloadObj.diagnosis_code = item.diagnosis_code;
                                if (modifier.unitVal) {
                                    payloadObj.numberOfUnits = Number(modifier.unitVal);
                                    let units = payloadObj.numberOfUnits ;
                                    let price = Number(units) * Number(item.perUnitPrice);
                                    payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                                    payloadObj.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                                }
                                if (item.nappi_code) {
                                    payloadObj.parentNappiCode = item.nappi_code
                                    payloadObj.reference_id += "-" + item.reference_id;
                                } else if (item.tariff_code) {
                                    payloadObj.parentTariffCode = item.tariff_code
                                    payloadObj.reference_id += "-" + item.reference_id;

                                    let lineTypeIndex = lineItemsArray.findIndex((element) => (
                                        element.tariff_code === item.tariff_code && element.delete !== true 
                                    ))
                                    if(lineTypeIndex > -1){
                                        lineItemsArray[lineTypeIndex].childAddition = payloadObj.tariff_code
                                    }
                                }
                                if(this.props.claimAsAssistant === 0){
                                    modifierArray.push(payloadObj);
                                }

                                let searchSpecialistAssis = [];
                                lineItemsArray.map((elem, index) => {
                                   if (elem.parentTariffCode === item.tariff_code && elem.delete !== true &&
                                    (elem.tariff_code === "0008" || elem.tariff_code === "0009") && index > currentIndex && index < nextTreatmentIndex)
                                    searchSpecialistAssis.push({...elem, index});
                                    return;
                                })
                                
                                if (searchSpecialistAssis && searchSpecialistAssis.length > 0) {
                                    searchSpecialistAssis.forEach((obj) => {
                                        let payloadObj1 = { ...payloadObj };
                                        indexArray.push(obj.index);
                                        payloadObj1.index = obj.index;
                                        payloadObj1.doctor_id = obj.doctor_id;
                                        if (item.tariff_code) {
                                            payloadObj1.parentTariffCode = obj.tariff_code;
                                            payloadObj1.superParentTariffCode = item.tariff_code;

                                            payloadObj1.reference_id  = row.code + "-" + obj.reference_id;

                                            let lineTypeIndex = lineItemsArray.findIndex((element) => {
                                                return (element.tariff_code === obj.tariff_code && 
                                                  (element.parentTariffCode ===  item.tariff_code || 
                                                  element.superParentTariffCode === item.tariff_code) &&
                                                  (!element.childAddition) && element.delete !== true )
                                                  })
                                              if(lineTypeIndex > -1){
                                                  lineItemsArray[lineTypeIndex].childAddition = payloadObj1.tariff_code
                                              }
                                        }
                                        modifierArray.push(payloadObj1);
                                    });
                                }
                            }
                        })
                    }
                    else if(["0026","0036","0037","0038","0041","0042","0043","0044","5433","5434","5435","5441","5442","5443","5444","5445","5448"].indexOf(modifier.code) > -1){
                        
                        lineItemsArray && lineItemsArray.forEach((item, index) => {
                            if (item.line_item_checked && item.line_item_checked === 1 && item.delete !== true) {
                                let payloadObj = { ...payload };
                                indexArray.push(index);
                                payloadObj.index = index;
                                payloadObj.diagnosis_code = item.diagnosis_code;
                                if (modifier.unitVal) {
                                    payloadObj.numberOfUnits = Number(modifier.unitVal);
                                    let units = payloadObj.numberOfUnits ;
                                    let price = item.anestheticUnitValue ? (Number(units) * Number(item.anestheticUnitValue)) : "";
                                    payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                                    payloadObj.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                                }
                                if (item.nappi_code) {
                                    payloadObj.parentNappiCode = item.nappi_code
                                    payloadObj.reference_id += "-" + item.reference_id;
                                } else if (item.tariff_code) {
                                    payloadObj.parentTariffCode = item.tariff_code
                                    payloadObj.reference_id += "-" + item.reference_id;
                
                                    let lineTypeIndex = lineItemsArray.findIndex((element) => (
                                        element.tariff_code === item.tariff_code && element.delete !== true 
                                    ))
                                    if(lineTypeIndex > -1){
                                        lineItemsArray[lineTypeIndex].childAddition = payloadObj.tariff_code
                                    }
                                }
                            modifierArray.push(payloadObj);
                        }
                    });
                    } else if (modifier.code === "0039") {
                        lineItemsArray && lineItemsArray.forEach((item, index) => {
                            if (item.line_item_checked && item.line_item_checked === 1 && item.delete !== true) {

                                let payloadObj = { ...payload };
                                indexArray.push(index);
                                payloadObj.index = index;
                                payloadObj.diagnosis_code = item.diagnosis_code;
                                if (this.state.duration) {
                                    let duration = this.state.duration;
                                    let x = 0;
                                    let unitVal = modifier.unitVal;
                                    if(duration > 60){
                                        duration = duration - 60
                                        x = Number(duration) / 15;
                                        if (x > parseInt(x)) {
                                            x = x + 1;
                                        }
                                        unitVal = x + unitVal;
                                    }
                                    payloadObj.quantity = this.state.duration;
                                    let numberOfUnits =  Number(unitVal);
                                    payloadObj.numberOfUnits = Number(numberOfUnits);
                                    payloadObj.perUnitPrice = Number(item.anestheticUnitValue);
                                    let price = Number(numberOfUnits) * Number(item.anestheticUnitValue);
                                    payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                                    payloadObj.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                                }
                                if (item.nappi_code) {
                                    payloadObj.parentNappiCode = item.nappi_code;
                                    payloadObj.reference_id += "-" + item.reference_id;
                                } else if (item.tariff_code) {
                                    payloadObj.parentTariffCode = item.tariff_code;
                                    payloadObj.reference_id += "-" + item.reference_id;

                                    let lineTypeIndex = lineItemsArray.findIndex((element) => (
                                        element.tariff_code === item.tariff_code && element.delete !== true 
                                    ))
                                    if(lineTypeIndex > -1){
                                        lineItemsArray[lineTypeIndex].childAddition = payloadObj.tariff_code
                                    }
                                }
                               // if(this.props.claimAsAssistant === 0){
                                    modifierArray.push(payloadObj);
                               // }
                            }
                        })
                    } else {
                         let finalObj = {...this.additionModifier(payload, modifier)};
                        modifierArray = finalObj && [...finalObj.modifierArray];
                        indexArray = finalObj && [...finalObj.indexArray]
                    }
                } else if (modifier.type === "RM" && modifier.extraRule === 1) {
                    if (modifier.code === "0005") {
                        // let procedureLineType = lineItemsArray && lineItemsArray.filter((item) => {
                        //     return item.line_type === "procedure" && item.delete !== true && item.line_item_checked && item.line_item_checked === 1
                        // })

                        let procedureLineType = [];
                         lineItemsArray && lineItemsArray.map((item, index) => {
                             if(item.line_type === "procedure" && item.delete !== true && item.line_item_checked && item.line_item_checked === 1){
                                 procedureLineType.push({...item, index});
                             }
                             return;
                        })




                        let consultationCode = [...ConsultationCodes];


                        let consultationExists = procedureLineType && procedureLineType.find((elem) => (
                            (consultationCode.indexOf(elem.tariff_code) > -1) && elem.delete !== true
                        ))

                        if (!isEmpty(consultationExists)) {
                            const continueFlag = await swal("A Modifier may not be associated with one of the consultation. Do you want to add this modifier to all?", {
                                className: "logout-swal-modal",
                                buttons: ["NO", "YES"],
                            });
               
                            if (!continueFlag) {
                                let array = [...procedureLineType];
                                procedureLineType = array.filter((elem) => (
                                    elem.tariff_code && elem.delete !== true &&
                                    (consultationCode.indexOf(elem.tariff_code) === -1)
                                ))
                            }
                        }

                        let excludeFlag = procedureLineType && procedureLineType.findIndex((elem) => (
                            elem.tariff_code && modifier.notApplicableTo.length > 0 && elem.delete !== true &&
                            (modifier.notApplicableTo.indexOf(elem.tariff_code) > -1)
                        ))
                        if (Number(excludeFlag) !== "NaN" && Number(excludeFlag) > -1) {

                            const continueFlag = await swal("0005 modifier may not be associated with one of the consultation. Do you want to add this modifier to all?", {
                                className: "logout-swal-modal",
                                buttons: ["No", "Yes"],
                            });

                            if (!continueFlag) {
                                let array = [...procedureLineType];
                                procedureLineType = array.filter((elem) => (
                                    elem.tariff_code && modifier.notApplicableTo.length > 0 && elem.delete !== true &&
                                    (modifier.notApplicableTo.indexOf(elem.tariff_code) === -1)
                                ))
                            }
                        }

                        let notApplicableFlag = -1;
                        procedureLineType && procedureLineType.length > 0 && procedureLineType.forEach((item) => {
                            notApplicableFlag = lineItemsArray && lineItemsArray.findIndex((elem) => (
                                elem.line_type === "modifier" && elem.tariff_code && modifier.notApplicableWith.length > 0 &&
                                item.tariff_code === elem.parentTariffCode && elem.delete !== true &&
                                (modifier.notApplicableWith.indexOf(elem.tariff_code) > -1)
                            ))

                            if (Number(notApplicableFlag) !== "NaN" && Number(notApplicableFlag) > -1) {
                                return notApplicableFlag;
                            }

                        })
                        if (Number(notApplicableFlag) !== "NaN" && Number(notApplicableFlag) > -1) {
                            const continueFlag = await swal(row.code + " modifier may not be applicable with one of already added modifier. Do you want to add this modifier to all?", {
                                className: "logout-swal-modal",
                                buttons: ["No", "Yes"],
                            });

                            if (!continueFlag) {
                                let array = [...procedureLineType];
                                procedureLineType = array.filter((elem) => (
                                    elem.tariff_code !== lineItemsArray[notApplicableFlag].tariff_code && lineItemsArray[notApplicableFlag].delete !== true
                                ))
                            }
                        }
                        if (procedureLineType || procedureLineType.length > 0) {
                            procedureLineType.sort(function (a, b) {
                                let keyA = a.calculatedPrice, keyB = b.calculatedPrice;
                                // Compare the 2 prices
                                if (keyA < keyB) return 1;
                                if (keyA > keyB) return -1;
                                return 0;
                            });

                           
                           let modiferPercent = modifier.percentage;


                            procedureLineType && procedureLineType.forEach((item, index) => {


                            // procedureLineType && procedureLineType.forEach((item, inde123x) => {   //item50
                                let payloadObj = { ...payload };
                                indexArray.push(item.index);
                                payloadObj.index = item.index;


                                let modiferExist = modifierArray && modifierArray.filter((elem) => {
                                    return elem.line_type === "modifier" &&
                                        elem.tariff_code === "0005" && elem.delete !== true
                                })


                                if (modiferExist && modiferExist.length > 0) {
                                    modiferPercent = modiferPercent > 25 ? (modiferPercent - 25) : modiferPercent
                                } 

                                payloadObj.diagnosis_code = item.diagnosis_code;
                                payloadObj.markupPercent = modiferPercent;
                                if (modiferPercent) {
                                    let price = this.getPercentageVal(Number(item.calculatedPrice), modiferPercent);
                                    price = price ? Number(price.toFixed(2)) : 0;
                                    payloadObj.base_price = Number(item.calculatedPrice) - this.getPercentageVal(Number(item.calculatedPrice), modiferPercent);
                                   let parentIndex = lineItemsArray.findIndex((elem) => (
                                        elem.tariff_code === item.tariff_code && elem.delete !== true && !elem.priceModified
                                    ))
                                    // console.log('payloadObj.base_price',payloadObj.base_price);   //item50
                                    
                                    // let i = 0
                                    // let parentIndex = _.map(_.keys(_.pickBy(lineItemsArray, {tariff_code:item.tariff_code})), Number)
                                    // if(let ab in obj){
                                        
                                    // }
                                    // parentIndex = parentIndex[0]
                                    // let parentIndex = lineItemsArray.findIndex((elem) => (
                                    //     elem.tariff_code === item.tariff_code && elem.delete !== true
                                    // ))

                                    // let parentIndex = inde123x
                                    // console.log('parentIndex up', parentIndex, inde123x)    // item50
                                    if (Number(parentIndex) !== "NaN" && Number(parentIndex) > -1) {
                                        if(this.props.claimAsAssistant === 0){
                                            lineItemsArray[parentIndex].price = price;
                                        }
                                        lineItemsArray[parentIndex].calculatedPrice = price;
                                        lineItemsArray[parentIndex].priceModified = true;
                                       // lineItemsArray[parentIndex].childAddition = payloadObj.tariff_code
                                    }
                           // payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                                }
                                if (item.tariff_code) {
                                    payloadObj.parentTariffCode = item.tariff_code
                                    payloadObj.reference_id += "-" + item.reference_id;
                                }
                                // console.log('payloadObj=========', payloadObj)
                                modifierArray.push(payloadObj);
                            })
                        }
                    } else if (modifier.code === "0057") {

                        lineItemsArray && lineItemsArray.forEach((item, index) => {
                            if (item.line_item_checked && item.line_item_checked === 1 && item.delete !== true) {
                                let modiferLineTypeExist = lineItemsArray && lineItemsArray.filter((elem) => {
                                    return elem.line_type === "modifier" &&
                                        elem.tariff_code === "0057" && elem.delete !== true
                                })                      
                                let modiferExist = modifierArray && modifierArray.filter((elem) => {
                                    return elem.line_type === "modifier" &&
                                        elem.tariff_code === "0057" && elem.delete !== true
                                })
                                let modiferPercent = modifier.percentage;
                                if ((modiferLineTypeExist && modiferLineTypeExist.length > 0) || (modiferExist && modiferExist.length > 0)) {
                                    modiferPercent = modiferPercent > 25 ? (modiferPercent - 25) : modiferPercent;
                                }
                                let payloadObj = { ...payload };
                                indexArray.push(index);
                                payloadObj.index = index;
                                payloadObj.diagnosis_code = item.diagnosis_code;
                                if (item.calculatedPrice) {
                                    let price = this.getPercentageVal(Number(item.calculatedPrice), modiferPercent);
                                    price = price ? Number(price.toFixed(2)) : 0;
                                    payloadObj.base_price = Number(item.calculatedPrice) - this.getPercentageVal(Number(item.calculatedPrice), modiferPercent);
                                    if(this.props.claimAsAssistant === 0){
                                        lineItemsArray[index].price = price;
                                    }
                                    lineItemsArray[index].calculatedPrice = price;
                                   // lineItemsArray[index].childAddition = payloadObj.tariff_code
                                }
                                if (item.tariff_code) {
                                    payloadObj.parentTariffCode = item.tariff_code
                                    payloadObj.reference_id += "-" + item.reference_id;
                                }
                                modifierArray.push(payloadObj);
                            }
                        })

                    } else if (modifier.code === "0063") {

                        lineItemsArray && lineItemsArray.forEach((item, index) => {
                            if (item.line_item_checked && item.line_item_checked === 1 && item.delete !== true) {
                                let payloadObj = { ...payload };
                                indexArray.push(index);
                                payloadObj.index = index;
                                payloadObj.diagnosis_code = item.diagnosis_code;
                                if (modifier.percentage) {
                                    let price = Number(item.calculatedPrice) - this.getPercentageVal(Number(item.calculatedPrice), modifier.percentage)
                                    price = price ? Number(price.toFixed(2)) : 0;
                                    payloadObj.base_price = this.getPercentageVal(Number(item.calculatedPrice), modifier.percentage)
                                    if(this.props.claimAsAssistant === 0){
                                        lineItemsArray[index].price = price;
                                    }
                                    lineItemsArray[index].calculatedPrice = price;
                                    //lineItemsArray[index].childAddition = payloadObj.tariff_code
                                }
                                if (item.nappi_code) {
                                    payloadObj.parentNappiCode = item.nappi_code
                                    payloadObj.reference_id += "-" + item.reference_id;
                                } else if (item.tariff_code) {
                                    payloadObj.parentTariffCode = item.tariff_code
                                    payloadObj.reference_id += "-" + item.reference_id;
                                }
                                if(this.props.claimAsAssistant === 0){
                                    modifierArray.push(payloadObj);
                                }

                                // let searchSpecialistAssis = lineItemsArray.filter((elem) => (
                                //     elem.parentTariffCode === item.tariff_code && elem.delete !== true &&
                                //     (elem.tariff_code === "0008" || elem.tariff_code === "0009")
                                // ))

                                let searchSpecialistAssis = [];
                                  lineItemsArray.map((elem, index) => {
                                      if(elem.parentTariffCode === item.tariff_code && elem.delete !== true &&
                                    (elem.tariff_code === "0008" || elem.tariff_code === "0009"))
                                    searchSpecialistAssis.push({...elem, index});
                                    return
                                  })


                                if (searchSpecialistAssis && searchSpecialistAssis.length > 0) {
                                    searchSpecialistAssis.forEach((obj) => {
                                        let payloadObj1 = { ...payloadObj };
                                        payloadObj1.doctor_id = obj.doctor_id;
                                        indexArray.push(obj.index);
                                        payloadObj.index = obj.index;
                                        if (item.tariff_code) {
                                            payloadObj1.parentTariffCode = obj.tariff_code;
                                            payloadObj1.superParentTariffCode = item.tariff_code;
                                            payloadObj1.reference_id = row.code + "-" + obj.reference_id

                                            //  let lineTypeIndex = lineItemsArray.findIndex((element) => {
                                            //     return (element.tariff_code === obj.tariff_code && 
                                            //       (element.parentTariffCode ===  item.tariff_code || 
                                            //       element.superParentTariffCode === item.tariff_code) &&
                                            //      !element.childAddition && element.delete !== true )
                                            //       })
                                            //   if(lineTypeIndex > -1){
                                            //       lineItemsArray[lineTypeIndex].childAddition = payloadObj1.tariff_code
                                            //   }
                                        }
                                        modifierArray.push(payloadObj1);
                                    });
                                }
                            }
                        })
                    }
                } else if (modifier.type === "CM" && modifier.extraRule === 1) {
                    if (modifier.code === "0011") {
                        
                        lineItemsArray && lineItemsArray.forEach((item, index) => {
                            if (item.line_item_checked && item.line_item_checked === 1 && item.delete !== true) {

                                // console.log("item", index);

                                currentIndex = index; 

                                nextTreatmentIndex = lineItemsArray.findIndex((elem, index) => elem.line_type == "procedure" && index > currentIndex && elem.delete !== true);
                                nextTreatmentIndex = nextTreatmentIndex == -1 ? 100000 : nextTreatmentIndex;
                                // console.log("nextTreatmentIndex", nextTreatmentIndex);

                                let payloadObj = { ...payload };
                                payloadObj.index = currentIndex;
                                indexArray.push(currentIndex)
                                payloadObj.diagnosis_code = item.diagnosis_code;
                                if (this.state.duration) {
                                    let x = Number(this.state.duration) / 30;
                                    if (x > parseInt(x)) {
                                        x = x + 1;
                                    }
                                    payloadObj.quantity = this.state.duration;
                                    let numberOfUnits = parseInt(x) * Number(modifier.unitVal);
                                    let units = Number(numberOfUnits);
                                    payloadObj.numberOfUnits = Number(units);
                                    payloadObj.perUnitPrice = Number(item.perUnitPrice);
                                    let price = Number(units) * Number(item.perUnitPrice);
                                    payloadObj.price = price ? Number(price.toFixed(2)) : 0;
                                    payloadObj.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
                                }
                                if (item.nappi_code) {
                                    payloadObj.parentNappiCode = item.nappi_code;
                                    payloadObj.reference_id += "-" + item.reference_id;
                                } else if (item.tariff_code) {
                                    payloadObj.parentTariffCode = item.tariff_code;
                                    payloadObj.reference_id += "-" + item.reference_id;

                                    let lineTypeIndex = lineItemsArray.findIndex((element) => (
                                        element.tariff_code === item.tariff_code && element.delete !== true 
                                    ))
                                    if(lineTypeIndex > -1){
                                        lineItemsArray[lineTypeIndex].childAddition = payloadObj.tariff_code
                                    }
                                }
                                if(this.props.claimAsAssistant === 0){
                                    modifierArray.push(payloadObj);
                                }

                                // let searchSpecialistAssis = lineItemsArray.filter((elem, index) => (
                                //      index > currentIndex && index < nextTreatmentIndex && 
                                //     elem.parentTariffCode === item.tariff_code && elem.delete !== true &&
                                //     (elem.tariff_code === "0008" || elem.tariff_code === "0009")
                                // ))

                                let searchSpecialistAssis = [];
                                 lineItemsArray.map((elem, index) => {
                                     if(
                                          index > currentIndex && index < nextTreatmentIndex && 
                                    elem.parentTariffCode === item.tariff_code && elem.delete !== true &&
                                    (elem.tariff_code === "0008" || elem.tariff_code === "0009")
                                     ){
                                         searchSpecialistAssis.push({...elem, index})
                                         return
                                     }
                                    return
                                 })



                                // console.log("searchSpecialistAssis", searchSpecialistAssis);

                                if (searchSpecialistAssis && searchSpecialistAssis.length > 0) {
                                    searchSpecialistAssis.forEach((obj) => {
                                        let payloadObj1 = { ...payloadObj };
                                        indexArray.push(obj.index);
                                        payloadObj1.index = obj.index;
                                        // console.log("assistantn index", payloadObj1.index)
                                        payloadObj1.doctor_id = obj.doctor_id;
                                        if (item.tariff_code) {
                                            payloadObj1.parentTariffCode = obj.tariff_code;
                                            payloadObj1.superParentTariffCode = item.tariff_code;
                                            payloadObj1.reference_id = row.code + "-" + obj.reference_id

                                             let lineTypeIndex = lineItemsArray.findIndex((element) => {
                                                return (element.tariff_code === obj.tariff_code && 
                                                  (element.parentTariffCode ===  item.tariff_code || 
                                                  element.superParentTariffCode === item.tariff_code) &&
                                                  !element.childAddition && element.delete !== true )
                                                  })
                                              if(lineTypeIndex > -1){
                                                  lineItemsArray[lineTypeIndex].childAddition = payloadObj1.tariff_code
                                              }
                                        }
                                        modifierArray.push(payloadObj1);
                                    });
                                }
                            }
                        })
                    }
                } else {
                    lineItemsArray && lineItemsArray.forEach((item, index) => {
                        if (item.line_item_checked && item.line_item_checked === 1 && item.delete !== true) {

                            let payloadObj = { ...payload };
                            payloadObj.index = index;
                            indexArray.push(index);
                            payloadObj.diagnosis_code = item.diagnosis_code;

                            if (item.nappi_code) {
                                payloadObj.parentNappiCode = item.nappi_code
                                payloadObj.reference_id += "-" + item.reference_id;
                            } else if (item.tariff_code) {
                                payloadObj.parentTariffCode = item.tariff_code
                                payloadObj.reference_id += "-" + item.reference_id;
                                let lineTypeIndex = lineItemsArray.findIndex((element) => (
                                    element.tariff_code === item.tariff_code && element.delete !== true 
                                ))
                                if(lineTypeIndex > -1){
                                    lineItemsArray[lineTypeIndex].childAddition = payloadObj.tariff_code
                                }
                            }
                            modifierArray.push(payloadObj);
                            // console.log("modiiffffiiiiieeeeeerrrrrrrrr", modifierArray)
                        }
                    })
                }
            } else {
                let payloadObj = { ...payload };
                payloadObj.diagnosis_code = this.state.diagnosis_string;
                modifierArray.push(payloadObj);
            }


          modifierArray.length > 0 && modifierArray.sort((a,b) => a.index - b.index);

            modifierArray.length > 0 && modifierArray.forEach((item, index) => {
                if (item.parentNappiCode) {
                    let lineTypeIndex = lineItemsArray.findIndex((element) => (
                        element.nappi_code === item.parentNappiCode && element.delete !== true
                    ))

                    const addIndex = indexArray.filter((indexNumber) => indexNumber < item.index);
                    let skipIndex = addIndex && addIndex.length ? parseInt(item.index)+parseInt(addIndex.length) : parseInt(item.index);
                    skipIndex = skipIndex+1;
                    lineItemsArray.splice(skipIndex, 0, item)

                    // if (typeof lineTypeIndex === "number" && lineTypeIndex > -1) {
                    //     lineItemsArray.splice(item.index + 1 + index, 0, item)
                    // }


                } else if (item.parentTariffCode && item.modifierType !== "RM") {

                   
                    // let lineTypeIndex = lineItemsArray.findIndex((element, index) => {
                    //   return  element.tariff_code === item.parentTariffCode && element.delete !== true 
                    //      && element.childAddition === item.tariff_code 
                    // })
                   
                   
                    // if (typeof lineTypeIndex === "number" && lineTypeIndex > -1) {
                        lineItemsArray[item.index].childAddition = ""
                        const addIndex = indexArray.filter((indexNumber) => indexNumber < item.index);
                        let skipIndex = addIndex && addIndex.length ? parseInt(item.index)+parseInt(addIndex.length) : parseInt(item.index);
                        skipIndex = skipIndex+1;
                        lineItemsArray.splice(skipIndex, 0, item)
                    // }
                   
                  
              
                } else if (item.parentTariffCode && item.modifierType === "RM") {
                    // let lineTypeIndex = lineItemsArray.findIndex((element, index) => (
                    //     element.tariff_code === item.parentTariffCode && element.delete !== true && element.modifierApplied !== true 
                    // )) 
                   
                    
                    // if (typeof lineTypeIndex === "number" && lineTypeIndex > -1) {
                        const addIndex = indexArray.filter((indexNumber) => indexNumber < item.index)
                        let skipIndex = addIndex && addIndex.length ? parseInt(item.index)+parseInt(addIndex.length) : parseInt(item.index);
                        skipIndex = skipIndex+1;
                        lineItemsArray[item.index].modifierApplied = true
                        lineItemsArray.splice(skipIndex, 0, item)
                    // }
                } else {
                    lineItemsArray.push(item);
                }
            })


            this.setState({
                isLoading: false
            })
            this.props.updateState(lineItemsArray);
        } else {
            this.setState({
                errorMessage: this.props.modifierLookupData.error,
                isLoading: false
            })

            setTimeout(() => {
                this.setState({
                    errorMessage: ""
                });
            }, 3000);
        }



    }

      // Adding actions edit and delete icons
    externalPractionerActionsFormatter = (cell, row) => {
        console.log("First Click")
        return (
            <div>

                <span title="Add External Practitioner" onClick={() => this.handleAddExternalPractitioner(row)}>
                    <i className="fa fa-plus billing-plus-icon ml-2"></i>
                </span>
            </div>
        );
    }

    // Adding actions edit and delete icons
    actionsFormatter = (cell, row) => {
        return (
            <div>

                <span title="Add Modifier" onClick={() => this.handleCheckModifier(row)}>
                    <i className="fa fa-plus billing-plus-icon ml-2"></i>
                </span>
            </div>
        );
    }


    /**
     * This method will be called when there is not data or data is being fetched to show the loader.
     */
    setLoader() {
        if (this.state.isDataFetched) {
            return <p>There is no data to display</p>;
        } else {
            return (
                <div>
                    <img src={ttmLoader} alt='loader' className="loader-image" />
                </div>
            );
        }
    }

    /**
    * This method will be called to format the table data for valid data.
    * @param {string} data of the table column.
    * @returns {string} data or Not available string
    */
    checkValidData = (data) => {
        if (!data) {
            return "Not Available";
        } else {
            return data;
        }
    }

    checkBooleanData = (data) => {
        if (data === 1) {
            return "Yes";
        } else {
            return "No";
        }
    }

    /**
    * This method will be called to format the table data for valid data.
    * @param {string} data of the table column.
    * @returns {string} data with first letter capital or Not available string
    */
    detailFormatter = (data) => {
        if (!data) {
            return "Not Available";
        } else {
            return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
        }
    }

    //   /**
    //    * This method will clear all the filters which are selected.
    //    */
    //   handleClearFilters = () => {
    //     this.setState({
    //       page: 1,
    //       sortName: "",
    //       sortOrder: "",
    //       sortBy: "",
    //       isDataFetched: false
    //     }, () => {
    //       this.callListAPI();
    //     })
    //   }

    formatDescription = (cell, row) => {
        if (!cell) {
            return "Not Available"
        }

        return (
            <div className="description" title={cell}>{cell}</div>
        )
    }


    /**
   * This will return filter form HTML for the render method.
   */
    getHeaderFilter = () => {

        return (

            <div className={`row form-group `}>

                <div class="col-md-12 d-flex flex-column flex-md-row">
                    <input
                        type="text"
                        className={`form-control ${style.inputSearch}`}
                        name="search_key"
                        placeholder="Search here"
                        onChange={this.handleInputChange}
                        value={this.state.search_key}
                    // onChange={this.onSearchChange}
                    />
                    <div class="d-flex mt-2 mt-md-0">
                        <label class="form-control invoice-filter-label border-0">in</label>
                        <select
                            className="form-control"
                            id="search_filter"
                            name="search_filter"
                            onChange={this.handleInputSelectChange}
                            value={this.state.search_filter}
                        >
                            <option value="code">Code</option>
                            <option value="description">Description</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const listData = this.props.proceduresListData &&
            this.props.proceduresListData.proceduresList?.tariffCodes &&
            this.props.proceduresListData.proceduresList.tariffCodes?.pageResult;

        const externalListData = this.props.externalPractitionerListData &&
        this.props.externalPractitionerListData.externalPractitionerList;

        return (
            <div className="inventory-tab-wrapper flex-wrap">
                <div className="row">
                    <div className="col-md-12">
                        {this.getHeaderFilter()}
                    </div>
                </div>

                <div className="row">
                    <div className={`col-md-12`}>
                        <BootstrapTable
                            remote={true}
                            bordered={false}
                            data={this.state.list}
                            version="4"
                            search={false}
                            pagination
                            fetchInfo={{
                                dataTotalSize: listData && listData.totalCount ? listData.totalCount : 0,
                            }}
                            options={{
                                searchvalue: "",
                                sortName: this.state.sortName,
                                sortOrder: this.state.sortOrder,
                                onSortChange: this.onSortChange,
                                // onSearchChange: this.onSearchChange,
                                sizePerPage: 5,
                                page: this.state.page,
                                onPageChange: this.onPageChange,
                                noDataText: this.setLoader(),
                            }}>
                            <TableHeaderColumn
                                dataField="code"
                                isKey={true}
                                dataFormat={this.checkValidData}
                                width="10%"
                            >
                                Code
                </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="description"
                                dataFormat={(cell, row) => this.formatDescription(cell, row)}
                                width="80%"
                            >
                                Description
               </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="id"
                                width="10%"
                                dataFormat={this.actionsFormatter}
                            >
                                Add
               </TableHeaderColumn>
                        </BootstrapTable>
                        {this.state.isLoading ? (
                            <div className={"loadingWrapper"}>
                                <img
                                    src={ttmLoader}
                                    alt="loader"
                                    className={style.loading}
                                />
                            </div>
                        ) : (
                                <div className={"textCenter"}>
                                    {this.state.errorMessage && (
                                        <p className=" error-message">
                                            {this.state.errorMessage}
                                        </p>
                                    )}
                                </div>
                            )}
                        <Modal
                            isOpen={this.state.isModalOpen}
                            toggle={this.toggle}
                            className={style.deleteReason}
                            centered
                        >
                            <ModalHeader
                                toggle={this.toggle}
                                className={style.deleteReasonHeader}
                            >
                                Duration of Surgery
            </ModalHeader>
                            <ModalBody>
                                <Formik
                                    initialValues={this.state}
                                    enableReinitialize={true}
                                    validationSchema={Yup.object().shape({
                                        duration: Yup.string().required("Duration is required")
                                            .matches(/^[0-9]*$/, "Enter numbers only"),
                                    })}
                                    onSubmit={this.handleSubmit}
                                >
                                    {({ errors, status, touched }) => (
                                        <Form>
                                            <div className={style.deleteReasonHeadingWrapper}>
                                                <p>
                                                    Please enter duration of surgery (in mins.){" "}
                                                </p>
                                            </div>
                                            <div className={style.deleteReasonFormWrapper}>
                                                <div className="form-group">
                                                    <Field
                                                        name="duration"
                                                        placeholder="Duration (in mins.)"
                                                        maxLength="4"
                                                        className={
                                                            "form-control" +
                                                            (errors.duration && touched.duration
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                        onChange={this.handleDurationChange}
                                                        value={this.state.duration}

                                                    >
                                                    </Field>
                                                    <ErrorMessage
                                                        name="duration"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />

                                                </div>
                                                <div className={`row ${style.deleteBtnWrapper}`}>
                                                    <div className="col-lg-12">
                                                        <div>
                                                            <button
                                                                type="submit"
                                                                className={`mr-4 ${style.deleteBtn}`}
                                                            >
                                                                Proceed
                        </button>
                                                            <button
                                                                type="button"
                                                                className={style.cancelBtn}
                                                                onClick={this.toggle}
                                                            >
                                                                Cancel
                        </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    )}

                                </Formik>
                            </ModalBody>
                        </Modal>
                        <Modal
                            isOpen={this.state.is0018ModalOpen}
                            toggle={this.toggleBMIModal}
                            className={style.deleteReason}
                            centered
                        >
                            <ModalHeader
                                toggle={this.toggleBMIModal}
                                className={style.deleteReasonHeader}
                            >
                                BMI Calculation
            </ModalHeader>
                            <ModalBody>
                                <Formik
                                    initialValues={this.state}
                                    enableReinitialize={true}
                                    validationSchema={Yup.object().shape({
                                        heightInMtr: Yup.string().required("Height is required")
                                            .matches(/^[0-9]\d{0,9}(\.\d{1,2})?%?$/, "Enter numbers only"),
                                        weightInKg: Yup.string().required("Weight is required")
                                            .matches(/^[0-9]\d{0,9}(\.\d{1,2})?%?$/, "Enter numbers only"),
                                    })}
                                    onSubmit={this.handleSubmitBMI}
                                >
                                    {({ errors, status, touched }) => (
                                        <Form>
                                            <div className={style.deleteReasonHeadingWrapper}>
                                                <p> BMI: {this.state.BMI}</p>
                                            </div>
                                            <div className={style.deleteReasonFormWrapper}>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="heightInMtr">Height (in M)
                                                    <span className="mandatory">*</span></label>
                                                            <Field
                                                                type="text"
                                                                name="heightInMtr"
                                                                maxLength="5"
                                                                placeholder="Height"
                                                                // value={this.state.height}
                                                                onChange={this.handleChange}
                                                                className={
                                                                    "form-control" +
                                                                    (errors.heightInMtr && touched.heightInMtr
                                                                        ? " is-invalid"
                                                                        : "")
                                                                }
                                                            >
                                                            </Field>
                                                            <ErrorMessage
                                                                name="heightInMtr"
                                                                component="div"
                                                                className="invalid-feedback"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="weightInKg">Weight (in Kg)
                                                    <span className="mandatory">*</span></label>

                                                            <Field
                                                                name="weightInKg"
                                                                type="text"
                                                                maxLength="6"
                                                                placeholder="Weight"
                                                                // value={this.state.weight}
                                                                className={
                                                                    "form-control" +
                                                                    (errors.weightInKg && touched.weightInKg
                                                                        ? " is-invalid"
                                                                        : "")
                                                                }
                                                                onChange={this.handleChange}
                                                            />
                                                            <ErrorMessage
                                                                name="weightInKg"
                                                                component="div"
                                                                className="invalid-feedback"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`row ${style.deleteBtnWrapper}`}>
                                                <div className="col-lg-12">
                                                    <div>
                                                        <button
                                                            type="submit"
                                                            className={`mr-4 ${style.deleteBtn}`}
                                                        >
                                                            Proceed
                        </button>
                                                        <button
                                                            type="button"
                                                            className={style.cancelBtn}
                                                            onClick={this.toggleBMIModal}
                                                        >
                                                            Cancel
                        </button>

                                                        {this.state.bmiErrorMessage && (
                                                            <p className="error-message justifyTextCenter">
                                                                {this.state.bmiErrorMessage}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    )}

                                </Formik>
                            </ModalBody>
                        </Modal>

                        <Modal
                            isOpen={this.state.isExternalPracModalOpen}
                            toggle={this.toggleExternalPractitionerModal}
                            className="externalPractitionerSelectionModal"
                            centered
                        >
                            <ModalHeader
                                toggle={this.toggleExternalPractitionerModal}
                                className={style.deleteReasonHeader}
                            >
                                External Practitioner
            </ModalHeader>
                            <ModalBody>
                            <BootstrapTable
                            remote={true}
                            bordered={false}
                            data={externalListData && externalListData.externalPractitioner ? 
                                externalListData.externalPractitioner : []}
                            version="4"
                            search={true}
                            pagination
                            fetchInfo={{
                                dataTotalSize: externalListData && externalListData.total ? externalListData.total : 0,
                            }}
                            options={{
                                searchvalue: this.state.externalPracPaylaod.search_key,
                                sortName: this.state.externalPracPaylaod.sortName,
                                sortOrder: this.state.externalPracPaylaod.sortOrder,
                                onSortChange: this.onExtSortChange,
                                onSearchChange: this.onExtSearchChange,
                                sizePerPage: 10,
                                page: this.state.externalPracPaylaod.page,
                                onPageChange: this.onExtPageChange,
                                noDataText: this.setLoader(),
                            }}>
                            <TableHeaderColumn
                                dataField="name"
                                isKey={true}
                                width="15%"
                                dataSort={true}
                                dataFormat={(cell, row) => this.nameFormatter(cell, row)}
                            >
                                Name
                </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="discipline_name"
                                dataFormat={this.checkValidData}
                                dataSort={true}
                                width="14%"
                            >
                                Practice Type
               </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="main_surgeon"
                                dataFormat={this.checkBooleanData}
                                dataSort={true}
                                width="90px"
                            >
                                Main Surgeon
               </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="assistant"
                                dataFormat={this.checkBooleanData}
                                width="100px"
                                dataSort={true}
                            >
                                Assistant
               </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="anaesthetist"
                                dataFormat={this.checkBooleanData}
                                width="115px"
                                dataSort={true}
                            >
                               Aneasthetics
               </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="locum"
                                dataFormat={this.checkBooleanData}
                                width="10%"
                                dataSort={true}
                            >
                                Locum
               </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="referring_practitioner"
                                dataFormat={this.checkBooleanData}
                                width="110px"
                                dataSort={true}
                            >
                                Referring Practitioner
               </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="billing_practise_pcns_number"
                                width="60px"
                                dataFormat={this.externalPractionerActionsFormatter}
                            >
                                Add
               </TableHeaderColumn>
                        </BootstrapTable>
                        {this.state.isLoading ? (
                            <div className={"loadingWrapper"}>
                                <img
                                    src={ttmLoader}
                                    alt="loader"
                                    className={style.loading}
                                />
                            </div>
                        ) : (
                                <div className={"textCenter"}>
                                    {this.state.errorMessage && (
                                        <p className=" error-message">
                                            {this.state.errorMessage}
                                        </p>
                                    )}
                                </div>
                            )}
                            </ModalBody>
                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}

// export default Users;
const mapStateToProps = (state) => {
    return {
        proceduresListData: state.proceduresList,
        modifierLookupData: state.modifierLookup,
        externalPractitionerListData: state.externalPractitionerList,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchProceduresList: (page, payload) => dispatch(fetchProceduresList(page, payload, 99)),
        fetchModifierLookup: (payload) => dispatch(fetchModifierLookup(payload)),
        fetchExternalPractitionerList: (payload) => dispatch(fetchExternalPractitionerList(payload)),
        
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modifiers);
